<div [class.active]="isFocus" class="title">{{title}}</div>
<input #inputEl autofocus type="number" [(ngModel)]="model" [placeholder]="placeholder" [style.width]="textboxWidth"
    (focus)="isFocus=true" (blur)="onBlur($event)" (keydown)="onKeyDown($event)" (keyup.enter)="onEnter()" (ngModelChange)="modelChange.emit($event)"
    [class.active]="isFocus" [attr.disabled]="disabled ? '' : null" />